/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Choose_New_T3Inputs */

const en_plan_choose_new_t3 = /** @type {(inputs: Plan_Choose_New_T3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export the plan`)
};

const id_plan_choose_new_t3 = /** @type {(inputs: Plan_Choose_New_T3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ekspor rencana`)
};

/**
* | output |
* | --- |
* | "Export the plan" |
*
* @param {Plan_Choose_New_T3Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const plan_choose_new_t3 = /** @type {((inputs?: Plan_Choose_New_T3Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Choose_New_T3Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_plan_choose_new_t3(inputs)
	return en_plan_choose_new_t3(inputs)
});